export const FETCH_LOAD_ALL_USERS_REQUEST = 'FETCH_LOAD_ALL_USERS_REQUEST'
export const FETCH_LOAD_ALL_USERS_SUCCESS = 'FETCH_LOAD_ALL_USERS_SUCCESS'
export const FETCH_LOAD_ALL_USERS_FALUIRE = 'FETCH_LOAD_ALL_USERS_FALUIRE'
export const SEARCH_USER='SEARCH_USER'
